import Vue from 'vue'
import VueRouter from 'vue-router'
import Xm from '@/views/Xm.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'xm', component: Xm }
]

const router = new VueRouter({
  routes
})

export default router
